/** ตารางแถวดิบสำหรับหน้าอ่านอย่างเดียวของ endpoint ใหม่ — คอลัมน์มาจากรายการที่หน้าจอระบุ ไม่เดาจากข้อมูล */

import type { ReactNode } from 'react';

import type { RecordRow } from '../../lib/backend/records';

export interface RecordColumn {
  readonly key: string;
  readonly label: string;
}

export function formatCell(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  if (typeof value === 'boolean') {
    return value ? 'ใช่' : 'ไม่';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
}

export interface RecordTableProps {
  readonly rows: readonly RecordRow[];
  readonly columns: readonly RecordColumn[];
  readonly testId: string;
  readonly empty?: string;
  /** คอลัมน์ท้ายตารางสำหรับปุ่มต่อแถว (ไม่ส่ง = ไม่มีคอลัมน์) */
  readonly rowActions?: (row: RecordRow) => ReactNode;
}

export function RecordTable({ rows, columns, testId, empty = 'ไม่มีรายการ', rowActions }: RecordTableProps) {
  return (
    <table className="cap-table" data-testid={testId}>
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key}>{column.label}</th>
          ))}
          {rowActions !== undefined && <th>จัดการ</th>}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 && (
          <tr>
            <td colSpan={columns.length + (rowActions === undefined ? 0 : 1)}>{empty}</td>
          </tr>
        )}
        {rows.map((row, index) => (
          <tr key={index}>
            {columns.map((column) => (
              <td key={column.key}>{formatCell(row[column.key])}</td>
            ))}
            {rowActions !== undefined && <td>{rowActions(row)}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
